<template>

<header id="header">
    <!-- Top Bar -->
    <div class="header-top d-none d-lg-block border-bottom" style="background-color: #f4f4f4;">
        <div class="container-fluid px-xl-5 d-flex justify-content-between align-items-center py-1">
            <div class="top-socials d-flex gap-3">
                <a href="mailto:empaqueslupa@gmail.com" class="text-dark"><font-awesome-icon icon="envelope" style="font-size: 11px;" /></a>
                <a href="https://www.instagram.com/empaqueslupa/" target="_blank" class="text-dark"><font-awesome-icon :icon="['fab', 'instagram']" style="font-size: 11px;" /></a>
            </div>
            <div class="top-message text-uppercase" style="font-size: 10px; color: #333; font-weight: 500;">
                Expertos en empaques
            </div>
            <div class="top-lang d-flex align-items-center cursor-pointer text-dark" style="font-size: 11px;">
                <span>Español</span>
                <font-awesome-icon icon="chevron-down" class="ms-1" style="font-size: 8px;" />
            </div>
        </div>
    </div>

    <!-- Middle Bar -->
    <div class="header-middle bg-white border-bottom py-3">
        <div class="container-fluid px-xl-5">
            <div class="row align-items-center">
                <div class="col-lg-2 col-6 d-flex align-items-center">
                    <router-link :to="{name:'home'}" class="logo me-4">
                        <img src="/img/LOGO-LUPA.jpg" alt="LUPA" class="logo-img" style="max-height: 50px;" />
                    </router-link>
                </div>
                <div class="col-lg-5 d-none d-lg-block">
                    <div class="search-wrap">
                        <div class="input-group search-group position-relative border" style="border-radius: 4px; overflow: hidden; border-color: #ddd !important;">
                            <input type="text" v-model="searchText" class="form-control border-0 py-2 ps-3 pe-5 shadow-none" 
                                   style="font-size: 1rem; color: #444;" 
                                   placeholder="¿Qué estás buscando?" />
                            <div class="position-absolute top-50 end-0 translate-middle-y pe-3 d-flex align-items-center gap-3" style="z-index: 10;">
                                <font-awesome-icon icon="camera" class="text-secondary" style="cursor: pointer;" />
                                <font-awesome-icon icon="search" class="text-secondary" style="cursor: pointer;" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-6 d-flex justify-content-end align-items-center gap-4">
                    <div class="header-actions text-dark d-flex gap-4 align-items-center">
                        <a href="#" class="text-decoration-none d-flex align-items-center">
                            <font-awesome-icon icon="map-marker-alt" class="fs-4 text-secondary me-2" />
                            <span class="text-primary text-decoration-underline" style="font-size: 0.85rem; font-weight: 600;">Ingresa tu ubicación</span>
                        </a>
                        <router-link :to="{name: 'checkout'}" class="text-dark text-decoration-none d-flex align-items-center">
                            <span class="badge bg-danger rounded-circle d-flex text-white align-items-center justify-content-center me-1" style="width: 22px; height: 22px; font-size: 0.8rem; background-color: #713083 !important;">{{productsInCart.length}}</span>
                            <font-awesome-icon icon="shopping-cart" class="fs-4 text-dark" />
                        </router-link>
                        <div class="d-none d-xl-flex text-dark align-items-center justify-content-center px-2" style="border-left: 1px solid #ddd; border-right: 1px solid #ddd; height: 35px; line-height: 1;">
                            <span class="text-muted text-uppercase text-center" style="font-size: 10px;">Programa<br><strong class="text-dark" style="font-size: 12px; font-weight: 800;">Puntos</strong></span>
                        </div>
                        <a href="#" class="text-dark text-decoration-none d-flex align-items-center">
                            <font-awesome-icon icon="user" class="fs-4 text-dark me-2" />
                            <span style="font-size: 0.85rem; font-weight: 600;">Mi Cuenta</span>
                        </a>
                    </div>
                    <button class="menu-toggle d-inline-block border-0 bg-transparent ms-3" @click="menu = !menu">
                        <font-awesome-icon :icon="menu ? 'times' : 'bars'" class="fs-3 text-dark" />
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Bottom Bar (Nav) -->
    <div class="header-bottom bg-white border-bottom d-none d-lg-block header-mega-nav" :class="{ fixed: isFixed }">
        <div class="container position-relative d-flex justify-content-between align-items-center py-1">
            <nav class="nav-wrap flex-grow-1">
                <ul class="nav d-flex flex-nowrap list-unstyled m-0 p-0">
                    <li v-for="cat in categories" :key="cat.id" class="nav-item position-static group-hover-trigger">
                        <a class="nav-link text-nowrap fw-bold" @click="getProductos(cat.id)">
                            {{cat.nombre}} <font-awesome-icon icon="chevron-down" class="ms-1 extra-small" />
                        </a>
                        
                        <!-- Mega Menu Dropdown -->
                        <div class="mega-menu-dropdown w-100 position-absolute start-0 bg-white shadow p-4" v-if="cat.sublevels && cat.sublevels.length > 0" style="border-top: 3px solid #713083; top: 100%;">
                            <div class="row w-100 m-0 text-start">
                                <div class="col-md-3 mb-4" v-for="subcat in cat.sublevels" :key="subcat.id">
                                    <h6 class="fw-bold mb-3 d-inline-block" style="color: #0099cc; cursor: pointer; font-size: 0.9rem;" @click="getProductos(subcat.id)">
                                        {{subcat.nombre}} <font-awesome-icon icon="chevron-right" style="font-size: 9px;"/>
                                    </h6>
                                    <ul class="list-unstyled" v-if="subcat.sublevels && subcat.sublevels.length > 0">
                                        <li class="mb-2" v-for="subsub in subcat.sublevels" :key="subsub.id">
                                            <a class="text-dark text-decoration-none subcat-link" @click="getProductos(subsub.id)" style="font-size: 0.85rem; cursor: pointer;">{{subsub.nombre}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </li>
                </ul>
            </nav>
            <div class="info-widgets d-flex align-items-center gap-2 ms-3">
                <div class="info-widget d-flex align-items-center bg-light px-2 py-1 rounded shadow-sm border">
                    <font-awesome-icon :icon="['fab', 'whatsapp']" class="info-icon whatsapp-icon me-1" />
                    <span class="fw-bold text-dark" style="font-size: 11px;">Soporte</span>
                </div>
                <div class="info-widget d-flex align-items-center bg-light px-2 py-1 rounded shadow-sm border ms-1">
                    <font-awesome-icon icon="box" class="info-icon me-1" />
                    <span class="fw-bold text-dark" style="font-size: 11px;">Personalizar</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Hamburger Menu -->
    <transition name="fade">
        <div class="hamburger-menu" v-if="menu">
            <ul>
                <li @click="menu = false"><router-link :to="{name:'home'}">Inicio</router-link></li>
                <li @click="menu = false"><router-link :to="{name:'nosotros'}">Quiénes Somos</router-link></li>
                <li @click="menu = false"><router-link :to="{name:'contacto'}">Contacto</router-link></li>
            </ul>
        </div>
    </transition>
</header>

</template>

<script>
//  <a class="btn btn-bd-download d-none d-lg-inline-block mb-3 mb-md-0 ml-md-3">
//           <font-awesome-icon icon="shopping-bag" />
//         </a>
        

        // <font-awesome-layers full-width class="fa-2x">
        //   <font-awesome-icon icon="shopping-bag" />
        //   <font-awesome-layers-text style="color:white" transform="down-2 shrink-9" value="1" />
        // </font-awesome-layers>


// <svg class="d-block" width="36" height="36" viewBox="0 0 612 612" xmlns="http://www.w3.org/2000/svg" focusable="false">
//           <title>Bootstrap</title>
//           <path fill="currentColor" d="M510 8a94.3 94.3 0 0 1 94 94v408a94.3 94.3 0 0 1-94 94H102a94.3 94.3 0 0 1-94-94V102a94.3 94.3 0 0 1 94-94h408m0-8H102C45.9 0 0 45.9 0 102v408c0 56.1 45.9 102 102 102h408c56.1 0 102-45.9 102-102V102C612 45.9 566.1 0 510 0z"></path>
//           <path fill="currentColor" d="M196.77 471.5V154.43h124.15c54.27 0 91 31.64 91 79.1 0 33-24.17 63.72-54.71 69.21v1.76c43.07 5.49 70.75 35.82 70.75 78 0 55.81-40 89-107.45 89zm39.55-180.4h63.28c46.8 0 72.29-18.68 72.29-53 0-31.42-21.53-48.78-60-48.78h-75.57zm78.22 145.46c47.68 0 72.73-19.34 72.73-56s-25.93-55.37-76.46-55.37h-74.49v111.4z"></path>
//         </svg>

  import { mapState} from 'vuex'
import MenuItem from '../MenuItem.vue'


	var URLactual = window.location;
  export default {
  components: { MenuItem },
    name: 'eheader',
	data(){
		return{
			menu: false,
			isFixed: false,
			buscar: '',
			searchText: '',
			redes:[
				{'nombre':'facebook', 'icono':'fab fa-facebook', 'link':'https://www.facebook.com/agencialupasas/?viewas=&show_switched_toast=false&show_switched_tooltip=false&show_podcast_settings=false'},
				{'nombre':'instagram', 'icono':'fab fa-instagram', 'link':'https://www.instagram.com/empaqueslupa/'},
				
			]
		}
	},
	
	computed: {
		...mapState(['productsInCart','categories'])
	},
	methods:{
		handleScroll() {
			this.isFixed = window.scrollY >= 50;
		},
		getProductos(id){
			this.$store.dispatch('getProductosCat', id)
			this.$router.push('/tienda/'+id).catch(()=>{})
		}
		
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	},
  }	
</script>

<style lang="scss" scoped>
#header {
  width: 100%;
  z-index: 1000;
}

/* TOP BAR */
.header-top {
  a {
    transition: all 0.2s;
    &:hover { color: #713083 !important; }
  }
}

/* MIDDLE BAR */
.header-middle {
  background: #fff;
}

.logo-img {
  max-height: 75px;
  width: auto;
  transition: all 0.3s ease;
}

.search-group {
  .input-group-text {
    border-right: 0;
  }
  input {
    box-shadow: none !important;
    &:focus {
      border-color: #dee2e6;
    }
  }
}

.rounded-start-pill {
  border-top-left-radius: 50rem !important;
  border-bottom-left-radius: 50rem !important;
}

.rounded-end-pill {
  border-top-right-radius: 50rem !important;
  border-bottom-right-radius: 50rem !important;
}



/* BOTTOM BAR / NAV */
.header-bottom {
  background: #fff;
  transition: all 0.3s ease;
  
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    box-shadow: 0 4px 15px rgba(0,0,0,0.08);
    z-index: 9999;
  }
}

.nav {
  .nav-item {
    .nav-link {
      color: #333;
      font-weight: 700;
      text-transform: uppercase;
      font-size: 12px;
      padding: 15px 18px;
      cursor: pointer;
      white-space: nowrap;
      
      &:hover {
        color: #713083 !important;
      }
    }
  }
}

.header-mega-nav .nav-item {
  position: static !important;
}

.mega-menu-dropdown {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 1050;
  pointer-events: none;
}

.group-hover-trigger:hover .mega-menu-dropdown {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}

.subcat-link:hover {
  color: #0099cc !important;
  text-decoration: underline !important;
}

.info-widgets {
  flex-shrink: 0;
  span {
    white-space: nowrap;
  }
}

.info-icon {
  font-size: 18px;
  color: #333;
  
  &.whatsapp-icon {
    color: #33e034;
  }
}

.extra-small {
  font-size: 10px;
}

/* MOBILE */
.menu-toggle {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: #333;
}

.hamburger-menu {
  background: #fff;
  position: absolute;
  top: 100%;
  right: 15px; /* Adjust according to container padding */
  width: 250px;
  z-index: 10000;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
  padding: 15px 20px;
  border-radius: 8px;
  border: 1px solid #eee;
  
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
      a {
        color: #333;
        font-weight: 600;
        text-decoration: none;
        display: block;
        padding: 10px 0;
        border-bottom: 1px solid #f8f9fa;
        transition: color 0.2s;
        &:hover {
          color: #713083;
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .hamburger-menu {
    width: 100%;
    right: 0;
    border-radius: 0;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>